import './lib/measurementBootstrap.js'
// Cross-origin error noise is silenced earlier, by /error-guard.js in <head>.
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { registerWebMCPTools } from '@/lib/webmcpTools'

// Register agent tools before React mounts so the Agentic Browsing audit
// always sees them, regardless of when the lazy widgets load.
registerWebMCPTools()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)